<script setup lang="ts">
import { ButtonSeverity, ButtonSize, TuButton } from "@tinyurldev/tu-ui-vue";

import xTwitterIcon from "@Resources/images/overhauling/x.png";
import googleIcon from "@Resources/images/overhauling/google.png";
import facebookIcon from "@Resources/images/overhauling/facebook.png";
import microsoftIcon from "@Resources/images/overhauling/microsoft.png";

//
// Props
interface Props {
  hasSocialAccount: (provider: string) => boolean
}

defineProps<Props>()

//
// Data
const socialLinks = [
  {
    id: "account_security_button_linkfb",
    icon: facebookIcon,
    provider: "facebook",
    label: "Facebook",
  },
  {
    id: "account_security_button_linkgoog",
    icon: googleIcon,
    provider: "google",
    label: "Google",
  },
  {
    id: "account_security_button_linktwtr",
    icon: xTwitterIcon,
    provider: "twitter",
    label: "X (Twitter)",
  },
  {
    id: "account_security_button_linkmsft",
    icon: microsoftIcon,
    provider: "microsoft",
    label: "Microsoft",
  },
]

//
// Methods
const redirectToProvider = (provider: string): void => {
  window.location.href = `/app/login/${provider}`
}
</script>

<template>
  <div class="link-social-accounts">
    <TuButton
      v-for="socialLink in socialLinks"
      :id="socialLink.id"
      :key="socialLink.id"
      :class="`_${socialLink.provider}`"
      :label="socialLink.label"
      :icon-asset="socialLink.icon"
      :severity="ButtonSeverity.CANCEL"
      :size="ButtonSize.MEDIUM"
      :aria-label="`Link ${socialLink.label} account`"
      :is-disabled="hasSocialAccount(socialLink.provider)"
      is-outlined
      @click="redirectToProvider(socialLink.provider)"
    />
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;
@use "@tinyurldev/tu-ui-vue/scss/settings/border.scss" as border;
@use "@tinyurldev/tu-ui-vue/scss/settings/colors.scss" as color;

.link-social-accounts {
  display: flex;
  flex-flow: wrap;
  gap: spacing.$xxxs;
  padding: spacing.$xxs;

  background-color: color.$background-secondary;
  border-radius: border.$medium-radius;
  border: border.$primary;
}
</style>
